import { FiImage } from "react-icons/fi";

const MarketingMaterialCard = ({ material, onClick }) => {
  return (
    <div
      className="group bg-white rounded-xl shadow-md hover:shadow-2xl transition-all duration-300 overflow-hidden transform hover:-translate-y-2 cursor-pointer"
      onClick={onClick}
    >
      <div className="relative overflow-hidden">
        {material.coverSrc ? (
          <img
            className="w-full h-80 object-cover transition-transform duration-300 group-hover:scale-105"
            src={material.coverSrc}
            alt={material.name}
          />
        ) : (
          <div className="w-full h-80 bg-gray-100 flex items-center justify-center text-gray-400">
            <FiImage size={56} />
          </div>
        )}
      </div>

      <div className="p-4">
        <h3
          className="text-lg font-semibold text-gray-800 dark:text-gray-200 text-center line-clamp-2"
          title={material.name}
        >
          {material.name}
        </h3>
      </div>
    </div>
  );
};

export default MarketingMaterialCard;

